module.exports = __webpack_public_path__ + "static/media/level-6-anim.d6c27329.gif";